module.exports = __webpack_public_path__ + "img/MTABAPPTEMP.eb164d24.svg";